module.exports = __webpack_public_path__ + "img/147ne.8ca9218b.svg";